import {ITraveler} from '../data/interfaces';

export function compareTravelersByReadyToShipDeadline(
  a: ITraveler,
  b: ITraveler
): number {
  const aTimestamp = a.readyToShipDeadline ? Date.parse(a.readyToShipDeadline) : Number.POSITIVE_INFINITY;
  const bTimestamp = b.readyToShipDeadline ? Date.parse(b.readyToShipDeadline) : Number.POSITIVE_INFINITY;

  if (aTimestamp !== bTimestamp) {
    return aTimestamp - bTimestamp;
  }

  return a.displayName.localeCompare(b.displayName);
}
